import Vue from 'vue'

/**
 * @author Jorge Nuñez López <>
 *
 * Create a movement and take supplies
 * @return {Object}
 */

export default (payload) =>
  Vue.$http.post(`purchase/warehouse/set-aside-for-sinister/`, payload)


// WEBPACK FOOTER //
// ./src/services/purchase/setAsideForSinister.js